import React from 'react';
import { motion } from 'framer-motion';
import PageHeader from '../components/PageHeader';

export default function Terminos({ onBack }) {
  const sections = [
    {
      title: "1. Aceptación de los términos",
      content: "Al acceder, registrarte o utilizar Veritas Scan aceptas quedar vinculado por estos Términos de Uso y nuestra Política de Privacidad. Si no estás de acuerdo con alguno de estos términos, no debes utilizar el servicio."
    },
    {
      title: "2. Descripción del servicio",
      content: `Veritas Scan es una herramienta online que utiliza inteligencia artificial (Gemini 2.5 Flash de Google DeepMind) para analizar imágenes, vídeos, documentos, textos y páginas web con el objetivo de determinar si han sido generados por IA o creados por humanos.

Todas las imágenes pasan previamente por Google Cloud Vision SafeSearch para moderar contenido inapropiado antes de ser analizadas. Las imágenes se procesan temporalmente a través de Cloudinary.

El servicio se ofrece en tres modalidades:

• Plan Gratuito (sin registro): hasta 5 análisis diarios por dispositivo (navegador). Soporta imágenes (JPG, PNG, GIF, WebP), vídeo, texto, PDF, DOCX y URLs. Historial local en el navegador.

• Plan Pro ($4.99/mes o $3.99/mes anual): análisis ilimitados, análisis de vídeo (MP4, MOV, AVI, WebM, MKV), historial en la nube, exportación de informes en PDF, análisis por lotes (hasta 10 archivos), API pública (500 llamadas/día), prioridad en cola.

• Plan Business ($29/mes o $23/mes anual): todo lo del plan Pro, hasta 5 usuarios incluidos, lotes de hasta 50 archivos, API con 5.000 llamadas/día, soporte prioritario por email, factura para empresa.`
    },
    {
      title: "3. Registro y cuenta de usuario",
      content: `Para acceder a funcionalidades de pago o al historial en la nube es necesario crear una cuenta. Al registrarte:

• Debes proporcionar información veraz y actualizada.
• Eres responsable de mantener la confidencialidad de tus credenciales.
• Debes notificarnos inmediatamente si sospechas de un acceso no autorizado.
• Puedes registrarte con email y contraseña, o mediante Google OAuth.
• El panel de Seguridad muestra información de tu sesión activa (IP, geolocalización aproximada, ISP, navegador y dispositivo) para que puedas detectar accesos no autorizados.

Nos reservamos el derecho de suspender o eliminar cuentas que infrinjan estos términos.`
    },
    {
      title: "4. Planes de pago y suscripciones",
      content: `Los planes Pro y Business se facturan mensualmente o anualmente (con descuento del 20%) a través de Stripe. Al suscribirte:

• Autorizas el cobro recurrente en el método de pago proporcionado.
• Precios: Pro $4.99/mes ($3.99/mes anual) · Business $29/mes ($23/mes anual).
• Puedes cancelar en cualquier momento desde tu perfil (sección Plan → Gestionar suscripción). La cancelación es efectiva al final del período en curso.
• No se realizan reembolsos por períodos parciales ya facturados, salvo lo exigido por la normativa aplicable.
• Los precios pueden modificarse con un preaviso mínimo de 30 días por email.
• Si hay un error en el cobro, puedes sincronizar tu plan manualmente desde el perfil.`
    },
    {
      title: "5. Moderación de contenido",
      content: `Todas las imágenes subidas a Veritas Scan pasan por un sistema de moderación en dos capas antes del análisis:

1. Google Cloud Vision SafeSearch: detecta automáticamente contenido adulto, violento, explícito o que involucre menores. Las imágenes que superen los umbrales de seguridad son rechazadas inmediatamente y no se procesan.
2. Análisis de Gemini: el modelo de IA procesa únicamente el contenido que ha superado la moderación previa.

Queda estrictamente prohibido subir:
• Imágenes sexuales explícitas, especialmente que involucren menores (CSAM)
• Contenido que muestre violencia real o gore
• Material que infrinja derechos de terceros

El incumplimiento de estas normas puede resultar en la suspensión inmediata de la cuenta y, cuando corresponda, en la notificación a las autoridades competentes.`
    },
    {
      title: "6. Historial en la nube",
      content: `Los usuarios registrados tienen su historial de análisis almacenado en la nube (MongoDB Atlas), vinculado a su cuenta. Incluye el veredicto, confianza, explicación, tipo de archivo y nombre.

• Accesible desde cualquier dispositivo al iniciar sesión.
• Puedes eliminar análisis individuales o limpiar todo el historial en cualquier momento desde la aplicación.
• Los archivos originales no se almacenan, solo los metadatos del resultado.

Los usuarios sin cuenta disponen únicamente de historial local en el navegador (localStorage), que se pierde al borrar los datos del sitio.`
    },
    {
      title: "7. Exportación de informes",
      content: "Los usuarios con plan Pro o Business pueden exportar cada resultado como informe en formato HTML/PDF descargable, que incluye veredicto, nivel de confianza, explicación detallada e indicadores detectados. Aplica a todos los tipos de contenido: imágenes, vídeos, documentos y textos. Los informes son orientativos y no constituyen prueba legal. Veritas Scan no se hace responsable del uso que el usuario realice de dichos informes."
    },
    {
      title: "8. Análisis por lotes",
      content: `Los usuarios Pro pueden subir hasta 10 archivos simultáneamente. Los usuarios Business hasta 50 archivos por lote. Formatos soportados: imágenes (JPG, PNG, GIF, WebP), documentos (PDF, DOCX, TXT).

• Cada archivo de un lote consume la misma cuota que un análisis individual.
• Los resultados de lotes se guardan en el historial en la nube.
• El tiempo de procesamiento varía según el número de archivos y su tamaño.`
    },
    {
      title: "9. API pública",
      content: `Los usuarios Pro y Business disponen de acceso a la API REST de Veritas Scan mediante una API key personal generada desde su perfil (sección API):

• Plan Pro: hasta 500 llamadas/día · Plan Business: hasta 5.000 llamadas/día.
• La API key es personal e intransferible. El usuario es responsable de su custodia y uso.
• Formato de las keys: vs_xxxxxxxxxxxxxxxx.
• La API soporta análisis de imágenes, vídeos, PDFs, texto y URLs.
• El uso de la API está sujeto a estos mismos Términos de Uso y a los límites de moderación de contenido.
• Veritas Scan puede suspender el acceso a la API en caso de uso abusivo, intentos de evasión de moderación o actividad que comprometa la estabilidad del servicio.`
    },
    {
      title: "10. Blog y contenido editorial",
      content: "Veritas Scan dispone de un blog con artículos sobre detección de IA, tutoriales y casos de uso. El contenido del blog es informativo y no constituye asesoramiento legal, técnico ni de ningún otro tipo. Veritas Scan se reserva el derecho de publicar, editar o eliminar contenido del blog en cualquier momento."
    },
    {
      title: "11. Uso aceptable",
      content: `El usuario se compromete a utilizar el servicio de forma legal y ética. Queda expresamente prohibido:

• Subir contenido ilegal o que infrinja derechos de terceros.
• Subir imágenes sexuales que involucren a menores (CSAM) — tolerancia cero.
• Utilizar el servicio para actividades fraudulentas o engañosas.
• Intentar sobrecargar, hackear o comprometer la seguridad del servicio.
• Realizar scraping automatizado o uso masivo no autorizado fuera de la API.
• Manipular el navegador o usar múltiples dispositivos/VPNs para eludir el límite diario por dispositivo.
• Intentar evadir los sistemas de moderación de contenido.
• Usar la API key de otro usuario o compartir las propias con terceros.`
    },
    {
      title: "12. Propiedad intelectual",
      content: "Los archivos que subes son de tu propiedad o tienes los derechos necesarios para analizarlos. Veritas Scan no reclama ningún derecho sobre el contenido que analizas. El servicio, su diseño, código, marca, logotipo y tecnología son propiedad de Veritas Scan y están protegidos por la legislación de propiedad intelectual aplicable."
    },
    {
      title: "13. Limitación de responsabilidad",
      content: `Veritas Scan proporciona los resultados del análisis como orientación, no como certeza absoluta. El servicio:

• No garantiza que todos los análisis sean 100% precisos. La IA puede cometer errores.
• No se hace responsable de decisiones tomadas basándose únicamente en los resultados.
• No se hace responsable de daños directos o indirectos derivados del uso del servicio.
• No garantiza la disponibilidad continua e ininterrumpida (pueden existir periodos de mantenimiento).
• No se hace responsable del contenido de los artículos del blog ni de las opiniones expresadas en ellos.

Los resultados deben interpretarse como una herramienta de apoyo, no como prueba definitiva ni legal.`
    },
    {
      title: "14. Eliminación de cuenta",
      content: "Puedes solicitar la eliminación de tu cuenta y todos tus datos en cualquier momento desde el panel de Cuenta → Eliminar cuenta. Una vez confirmada, se eliminarán tu perfil, historial de análisis en la nube y API key. Los datos de facturación se conservan durante el período legalmente exigido. Si tienes una suscripción activa, se cancelará automáticamente."
    },
    {
      title: "15. Modificaciones del servicio y los términos",
      content: "Nos reservamos el derecho de modificar el servicio (funcionalidades, precios, límites) y estos términos en cualquier momento. Las modificaciones de términos entrarán en vigor desde su publicación en esta página. Si tienes una cuenta registrada, te notificaremos por correo electrónico en caso de cambios sustanciales con al menos 15 días de antelación. El uso continuado del servicio tras las modificaciones implica su aceptación."
    },
    {
      title: "16. Legislación aplicable y jurisdicción",
      content: "Estos términos se rigen por la legislación española. Para cualquier disputa derivada del uso del servicio, las partes se someten a los juzgados y tribunales de España, con renuncia expresa a cualquier otro fuero que pudiera corresponderles, salvo los supuestos de fuero imperativo para consumidores."
    }
  ];

  return (
    <div className="min-h-screen bg-zinc-950 relative">
      <div className="scanlines" />
      <div className="fixed inset-0 pointer-events-none" style={{ background: 'radial-gradient(circle at 50% 0%, rgba(59, 130, 246, 0.08), transparent 60%)' }} />

      <PageHeader onBack={onBack} />

      <main className="relative z-10 max-w-4xl mx-auto px-4 sm:px-6 py-10 sm:py-16">
        <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} className="space-y-6 sm:space-y-8">

          <div className="space-y-2">
            <p className="font-mono text-xs tracking-widest text-blue-500 uppercase">Legal</p>
            <h1 className="font-heading text-3xl sm:text-4xl font-black">Términos de Uso</h1>
            <p className="text-zinc-500 font-mono text-sm">Última actualización: marzo 2026</p>
          </div>

          <div className="bg-amber-500/10 border border-amber-500/25 rounded-xl p-4 text-amber-300 font-mono text-xs leading-relaxed">
            Al usar Veritas Scan aceptas estos términos. Los puntos clave: moderación automática de contenido, límites de uso por plan, y que los resultados son orientativos y no constituyen prueba legal.
          </div>

          {sections.map(({ title, content }) => (
            <div key={title} className="bg-zinc-900 border border-zinc-800 rounded-xl p-5 sm:p-6 space-y-3">
              <h2 className="font-heading text-base sm:text-lg font-bold text-white">{title}</h2>
              <p className="text-zinc-400 leading-relaxed whitespace-pre-line text-sm">{content}</p>
            </div>
          ))}

        </motion.div>
      </main>
    </div>
  );
}
